import React from "react";
import Text from "../../component/mui/customText";
import { RELEASE } from "../../va-package/apis";
import build from "../../build.json";
import { useTranslation } from "react-i18next";
import RingLoader from "../../va-package/loader/ring2";
import { defaultTheme } from "../../theme/palette";

const AppLoading = () => {
  const { t } = useTranslation();
  return (
    <div className="relative w-full h-screen">
      <div className="h-[80%] justify-center items-center flex flex-col space-y-6">
        <div
          style={{
            backgroundImage: `url(/management/logo/logoApp.svg)`,

            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
          }}
          className="h-[7rem] w-[7rem]"
        />
        <RingLoader
          color={defaultTheme.primary.main}
          size={54}
          bgOpacity={0}
          speed={0.8}
          strokeLength={0.4}
          stroke={2}
        />
      </div>
      <div className="h-[20%] justify-center items-center flex">
        <Text size="subtitle1">
          {t(RELEASE)} : {`${build.release}`}
        </Text>
      </div>
    </div>
  );
};

export default AppLoading;
